module.exports = __webpack_public_path__ + "static/media/cannabis_webbanner_1344x513.59a2570d.jpg";